import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { RadiusParserOptions } from 'data/radiusParserOptions/radiusParserOptions.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  radiusParserOptionsData: RadiusParserOptions,
  originalDigitExtractionServerFormData: RadiusParserOptions | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.RADIUS_PARSER_OPTIONS_CREATE;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.RADIUS_PARSER_OPTIONS_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(radiusParserOptionsData, null, isEdit, originalDigitExtractionServerFormData),
    radiusParserOptionsData.id,
    AuditService.RADIUS_PARSER_OPTIONS,
    actionType,
  );
  return auditDetails as AuditDetails;
}
